/**
 * Tabitto プロフィールフック
 * 共通フックを使用し、コア機能のみ提供
 */
import { useAtom } from "jotai";
import { useProfileCore, profileKeys } from "@tabipla/hooks/profile";
import { userAtom } from "../atoms/auth-atoms";
import { apiClient } from "@/infrastructure/api/client";

// Re-export query keys for direct access if needed
export { profileKeys };

export function useProfile() {
  const [user, setUser] = useAtom(userAtom);

  const core = useProfileCore({
    apiClient,
    getUserId: () => user?.id ?? null,
    getUser: () => user,
    setUser,
  });

  return {
    user,
    ...core,
  };
}
